module.exports = __webpack_public_path__ + "img/tip.edfb550b.png";